/* all scripting related to the quotation pages */
var mainId = Cookies.get('quotation_product_id');

var dayPart = Cookies.get('quotation_daypart');
if (dayPart == null || dayPart.length < 1) {
  dayPart = '08:30';
  Cookies.set('quotation_daypart', '08:30', {
    expires: 0.04
  });
}

jQuery(document).ready(function() {

  initQuotation();

  /***** add a product to the quotation *****/
  jQuery('.product.quotation, .added-product').click(function() {
    jQuery(this).toggleClass('added');
    updateQuotation();
  });

  /***** sets quotation date *****/
  jQuery('.quotation-date .datepicker').change(function() {
    Cookies.set('quotation_date', jQuery(this).val(), {
      expires: 0.04
    });
  });

  /***** set budget to unknown *****/
  jQuery('.quotation-budget-unknown .__text').click(function() {
    setBudgetState(jQuery(this));
  });

  /* set wanted activitites */
  jQuery('input.sub-category').click(function() {
    composeCategories = new Array();
    jQuery('input.sub-category:checked').each(function() {
      composeCategories.push(jQuery(this).val());
    });

    Cookies.set('compose_categories', composeCategories, {
      expires: 0.04
    });
  });

  /* set daypart */
  jQuery('.__daypart select').change(function() {
    Cookies.set('quotation_daypart', jQuery(this).val(), {
      expires: 0.04
    });
  });

  /* set person amounts */
  jQuery('.__group-size input').change(function() {
    var $this = jQuery(this);

    if(parseInt($this.val()) <= parseInt(jQuery('.__child-group-size input').val())){
      jQuery('.__child-group-size input').val( ($this.val() - 1) );
      return; 
    }

    checkMinMax($this);
    Cookies.set('quotation_group_size', $this.val(), {
      expires: 0.04
    });
    updateQuotation();
  });

  jQuery('.__child-group-size input').change(function() {
    var $this = jQuery(this);
    
    if((parseInt($this.val()) + 1) > parseInt(jQuery('.__group-size input').val())){
      $this.val( (jQuery('.__group-size input').val() - 1) );
      return; 
    }

    Cookies.set('quotation_child_group_size', $this.val(), {
      expires: 0.04
    });
    updateQuotation();
  });

  jQuery('.added-products-dropdown-trigger').click(function() {
    jQuery('.added-products-container').slideToggle();
  });

  jQuery('input[type=number]').change(function() {
    var $this = jQuery(this);
    checkMinMax($this);
  });

  jQuery('.next-step').click(function() {
    var $this = jQuery(this);

    if (Cookies.get('quotation_group_size') == null || Cookies.get('quotation_group_size').length < 1) {
      alert('Voer het aantal personen in.');
      return false;
    } else if (Cookies.get('quotation_date') == null || Cookies.get('quotation_date').length < 1) {
      alert('Voer een datum in.');
      return false;
    }


    if (jQuery('input.group-size').length) {
      var min = parseInt(jQuery('input.group-size').attr('min'));
      var inputVal = parseInt(jQuery('input.group-size').val());
      if(inputVal < min){
        alert('de minimum groepgrootte is ' + min);
        jQuery('input.group-size').val(min);
        Cookies.set('quotation_group_size', min, {
          expires: 0.04
        });

        updateQuotation();
        return false;
      }
    }

    if ($this.hasClass('next-step--final')) {
      jQuery('.gform_footer input[type=submit]').click();
    }

    if ($this.hasClass('next-step--compose')) {
      if (Cookies.get('compose_categories') != null) {
        if (Cookies.get('compose_categories').length < 1) {
          alert('Kies ten minste 1 activiteit.');
          return false;
        }
      }
    }
  });
});

jQuery(document).on('click', '.quotation-bar.added-products .__added-product', function() {
  var id = jQuery(this).attr('data-id');
  jQuery('[data-id=' + id + ']').removeClass('added');
  updateQuotation();
});

function initQuotation() {
  var isCompose = jQuery('main').hasClass('compose-quotation');
  var isSimple = jQuery('main').hasClass('simple-quotation');
  var isFinal = jQuery('main').hasClass('final-quotation');

  if (isCompose) {
    Cookies.set('origin', 'compose', {
      expires: 0.04
    });

    jQuery('input[type=range]').rangeslider({
      polyfill: false,
      rangeClass: 'rangeslider',
      disabledClass: 'rangeslider--disabled',
      horizontalClass: 'rangeslider--horizontal',
      fillClass: 'rangeslider__fill',
      handleClass: 'rangeslider__handle',
      onSlide: function(position, value) {
        var $this = jQuery('.quotation-bar.budget .__budget-amount');
        jQuery('.quotation-budget-unknown .__text').removeClass('active');
        jQuery('.quotation-budget').removeClass('budget-unknown');
        $this.find('.from-budget').html(value);
        $this.find('.to-budget').html(value + 10);
      },
      onSlideEnd: function(position, value) {
        Cookies.set('quotation_from', value, {
          expires: 0.04
        });
        Cookies.set('quotation_to', (value + 10), {
          expires: 0.04
        });
        Cookies.set('budget_known', 'true', {
          expires: 0.04
        });
      }
    });

    if (Cookies.get('budget_known') === 'false') {
      setBudgetState(jQuery('.quotation-budget-unknown .__text'));
    }

    var initVal = 20;
    if (Cookies.get('quotation_from') != null) {
      jQuery('input[type=range]').val(Cookies.get('quotation_from')).change();
    } else {
      Cookies.set('quotation_from', initVal, {
        expires: 0.04
      });
      Cookies.set('quotation_to', (initVal + 10), {
        expires: 0.04
      });
      jQuery('.quotation-range-slider input').val(initVal).change();
    }

    var chosenCategories = Cookies.get('compose_categories');
    if (chosenCategories != null) {
      chosenCategories = chosenCategories.split(',');
      for (var i = 0; i < chosenCategories.length; i++) {
        jQuery('[value="' + chosenCategories[i] + '"]').attr('checked', 'checked');
      };
    }
  }

  if (isSimple) {
    Cookies.set('origin', 'simple');
    var chosenProducts = Cookies.get('products_' + mainId);
    if (chosenProducts != null) {
      chosenProducts = JSON.parse(chosenProducts);
      chosenProducts.forEach(function(product) {
        if (product != null) {
          jQuery('[data-id=' + product.id + ']').addClass('added');
        }
      });
    }
    updateQuotation();
  }

  if (isSimple || isCompose) {
    jQuery('.__daypart select').val(dayPart);
  }

  if (isFinal || isSimple || isCompose) {
    jQuery('.main-product .__product span').html(Cookies.get('title'));
    jQuery('.quotation-group-size .__group-size input').val(Cookies.get('quotation_group_size'));
    jQuery('.quotation-group-size .__child-group-size input').val(Cookies.get('quotation_child_group_size'));
    jQuery('.quotation-date .__date input').val(Cookies.get('quotation_date'));
  }

  /* Hide added products is there are none */
  checkAddedProductVisibility();
}


function updateQuotation() {
  var productIds = new Array();
  var pricePerPerson = parseFloat(Cookies.get('base_price'));
  var pricePerChild = parseFloat(Cookies.get('child_price'))
  var addedProductCount;
  jQuery('.added-product.additional').removeClass('show').addClass('hidden');

  jQuery('.product.quotation.added, .added-product.added').each(function(i) {
    var $this = jQuery(this);
    if ($this.hasClass('show') || $this.hasClass('init') || $this.hasClass('product')) {

      /* checks which added products are linked to the current quotation */
      setAddedProductState($this);

      /* add the price of the product to the quotation */
      if (parseInt($this.attr('data-price')) > 0) {
        pricePerPerson += parseFloat($this.attr('data-price'));
      }

      /* add the (child)price of the product to the quotation */
      if (parseInt($this.attr('data-child-price')) > 0) {
        pricePerChild += parseFloat($this.attr('data-child-price'));
      }

      /* save all added product ids to an array */
      productIds[i] = {
        'id': $this.attr('data-id'),
        'title': $this.attr('data-title'),
      };
    }
    addedProductCount = i;
  });


  jQuery('.added-products-dropdown-trigger span').html((addedProductCount + 1));

  setProductTags(productIds);
  updatePrice(pricePerPerson, pricePerChild);

  /* Hide added products is there are none */
  checkAddedProductVisibility();

  Cookies.set('products_' + mainId, JSON.stringify(productIds), {
    expires: 0.04
  });

}

function checkAddedProductVisibility() {
  if (jQuery('.added-product.show').length) {
    jQuery('.atomic-container.added_products').addClass('show');
  } else {
    jQuery('.atomic-container.added_products').removeClass('show');
  }
}

function setProductTags(products) {
  var container = jQuery('.quotation-bar .added-products-container').html('');
  var htmlTemplate = '<div class="__added-product" data-id="[id]">[title]<div class="remove"><div class="stripe"></div><div class="stripe"></div></div></div>';

  products.forEach(function(product) {
    productTag = htmlTemplate.replace('[title]', product.title).replace('[id]', product.id);
    container.append(productTag);
  });

  if (products.length < 1) {
    container.html('<p>-</p>');
    jQuery('.added-products-dropdown-trigger span').html('geen');
  }

}

function setAddedProductState($this) {

  if ($this.attr('data-linked-added-products') != null) {
    /* get the added products that are linked to the linked product */
    var addedProductIds = $this.attr('data-linked-added-products').split(',');

    /* loop through the added products that are linked to the current product, and set the proper state */
    addedProductIds.forEach(function(id) {
      if (id.length) {
        jQuery('.added-product.additional.hidden[data-id=' + id + ']').removeClass('hidden').addClass('show');
      }
    });
  }

}

function updatePrice(pricePerPerson, pricePerChild) {

  var group = parseInt(Cookies.get('quotation_group_size'));
  var childGroup = parseInt(Cookies.get('quotation_child_group_size'));
  
  var adultGroup = group;
  if(childGroup > 0 && pricePerChild){
    adultGroup = group - childGroup;
    var totalPriceChildren = pricePerChild * childGroup;
  }

  var totalPriceAdults = pricePerPerson * adultGroup;

  if (!totalPriceAdults) {
    totalPriceAdults = 0;
  }
  if (!totalPriceChildren) {
    totalPriceChildren = 0;
  }

  var totalPrice = totalPriceAdults + totalPriceChildren;

  Cookies.set('price_per_person_' + mainId, pricePerPerson);
  Cookies.set('price_per_child_' + mainId, pricePerChild);
  Cookies.set('total_price_' + mainId, totalPrice);

  jQuery('.__price .__total span').html(getFinancial(totalPrice));
  /* jQuery('.__price .__per-person span').html(getFinancial(pricePerPerson)); */
}

function checkMinMax($this) {
  var max = parseInt($this.attr('max'));
  var min = parseInt($this.attr('min'));
  var inputVal = parseInt($this.val());
  if (max != null) {
    if (inputVal > max) {
      $this.val(max);
      alert('Het maximum aantal is ' + max);
    }
  }
  if (min != null) {
    if (inputVal < min) {
      $this.val(min);
      alert('Het minimum aantal is ' + min);
    }
  }
}

function setBudgetState($this) {
  Cookies.set('budget_known', 'true', {
    expires: 0.04
  });
  $this.toggleClass('active');
  jQuery('.quotation-budget').toggleClass('budget-unknown');
  if ($this.hasClass('active')) {
    Cookies.set('budget_known', 'false', {
      expires: 0.04
    });
  }
}

function goBack() {
  window.history.back();
}

function getFinancial(n) {
  if (n % 1 != 0) {
    return parseFloat(n).toFixed(2).replace(/\./g, ',');
  } else {
    return parseInt(n) + ',-';
  }
}
